import { render, staticRenderFns } from "./ProdutoSelector.vue?vue&type=template&id=17a579c8&scoped=true"
import script from "./ProdutoSelector.vue?vue&type=script&lang=js"
export * from "./ProdutoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a579c8",
  null
  
)

export default component.exports